

























































































































import { RouteMeta, routes } from "@/router";
import { catNav, catVue } from "@/util/logging";

import { PermissionType } from "@/models/UserDataModel";
import { RouteConfig } from "vue-router";
import Vue from "vue";

export default Vue.extend({
   name: "SideNavigation",

   data(): {
      selectedPerms: number[];
      currentPermissions: number;
      originalPermissions: number;
      permissionsInitialized: boolean;
   } {
      return {
         selectedPerms: [],
         currentPermissions: 0,
         originalPermissions: 0,
         permissionsInitialized: false,
      };
   },

   methods: {
      routePath(route: RouteConfig): string {
         return route.meta && "navpath" in route.meta
            ? route.meta.navpath
            : route.path;
      },
      childPath(route: RouteConfig, child: RouteConfig): string {
         return this.routePath(route) + "/" + this.routePath(child);
      },

      checkRouteAndSubroute(route: RouteConfig): boolean {
         let showMe = false;

         if (!route.children || route.children.length == 0) return false;

         route.children.forEach(
            (child) =>
               (showMe = showMe || this.checkRoute(child.meta as RouteMeta)),
         );
         return showMe || this.checkRoute(route.meta as RouteMeta);
      },

      checkRoute(meta: RouteMeta | undefined): boolean {
         if (meta === undefined) return false;

         // Hide hidden elements
         if ("hidden" in meta && meta.hidden) return false;

         // Hide entries that require authentication if unauthenticated.
         if (!this.$store.state.auth.loggedIn) {
            if (meta.requiresAuth) return false;
            return true;
         }

         // console.log( "   loggedIn ... ");
         if (meta.hideAuthenticated) return false;

         // console.log( "   not hiding ... "+(meta.permissionMask!==undefined)+"-"+(meta.permissionMask!=0)+"-"+(( meta.permissionMask&this.$store.state.auth.user.permissions )==0));
         if (
            meta.permissionMask !== undefined &&
            meta.permissionMask != 0 &&
            (meta.permissionMask &
               this.$store.state.auth.user.Permissions) ==
               0
         )
            return false;

         if (process.env.NODE_ENV != "development") {
            if (
               meta.permissionMask !== undefined &&
               meta.permissionMask != 0 &&
               (meta.permissionMask & PermissionType.PERM_THOMAS) ==
                  PermissionType.PERM_THOMAS &&
               this.$store.state.auth.user.Name != "Thomas Ganter"
            )
               return false;
         }

         // Hide hidden elements
         if ("mandantFeature" in meta) {
            const what = ":" + meta.mandantFeature;
            //console.log("checking for '" + what + "'");

            return this.$store.state.auth.mandant.features.includes(what);
         }

         return true;
      },

      applySelectedPermissions(): void {
         const newPerms = this.selectedPerms.reduce(
            (acc, bit) => acc | bit,
            0,
         );
         this.currentPermissions = newPerms;
         try {
            this.$store.commit("auth/setPermissions", newPerms);
         } catch (e) {
            // Fallback: mutate user permissions if mutation not available
            if (this.$store.state.auth.user) {
               this.$store.state.auth.user.Permissions = newPerms;
            }
            catVue.warn(
               "setPermissions mutation missing; mutated user state directly",
            );
         }
         catVue.info(
            `Permissions changed to: 0x${newPerms
               .toString(16)
               .toUpperCase()}`,
         );
      },

      resetPermissions(): void {
         // Reset to saved original permissions
         const origPerms = this.originalPermissions;
         catVue.info(
            `RESET: originalPermissions=0x${origPerms
               .toString(16)
               .toUpperCase()}, currentPermissions was 0x${this.currentPermissions
               .toString(16)
               .toUpperCase()}`,
         );

         // Update UI immediately
         this.currentPermissions = origPerms;
         const newSelectedPerms = this.permissionOptions
            .filter((p) => (origPerms & p.bit) !== 0)
            .map((p) => p.bit);

         catVue.info(
            `RESET: Calculated selectedPerms: ${newSelectedPerms.join(
               ", ",
            )}`,
         );

         // Force Vue to recognize the change
         this.$set(this, "selectedPerms", newSelectedPerms);

         // Apply via mutation
         this.$store.commit("auth/setPermissions", origPerms);
         catVue.info(
            `Permissions reset to: 0x${origPerms
               .toString(16)
               .toUpperCase()}`,
         );
      },

      copyPermissions(): void {
         const text = `0x${this.currentPermissions
            .toString(16)
            .toUpperCase()}`;
         navigator.clipboard.writeText(text).then(() => {
            catVue.info(`Copied: ${text}`);
         });
      },
   },

   computed: {
      routes() {
         catNav.info("Accessing routes: ");
         catNav.debug(JSON.stringify(routes, null, 4));

         return routes;
      },

      showDebugSection(): boolean {
         // Show debug section for Thomas in dev mode
         if (process.env.NODE_ENV !== "development") return false;
         const user = this.$store.state.auth.user;
         return user && user.Name === "Thomas Ganter";
      },

      permissionOptions(): Array<{
         bit: number;
         label: string;
         description: string;
      }> {
         return [
            {
               bit: PermissionType.PERM_BABU,
               label: "BABU",
               description: "BahnhofsBuch -> Base",
            },
            {
               bit: PermissionType.PERM_BABU_CREATE,
               label: "BABU_CREATE",
               description: "BahnhofsBuch -> Create",
            },
            {
               bit: PermissionType.PERM_FEHLERLISTEN,
               label: "FEHLER",
               description: "Fehlerlisten lesen",
            },
            {
               bit: PermissionType.PERM_FEHLERLISTEN_SAVE,
               label: "FEHLER_SAVE",
               description: "Fehlerlisten speichern",
            },
            {
               bit: PermissionType.PERM_REMI,
               label: "REMI",
               description: "Remissionen",
            },
            {
               bit: PermissionType.PERM_BUCH_USERS,
               label: "BUCH_USERS",
               description: "Buchbereich Nutzer",
            },
            {
               bit: PermissionType.PERM_BUCH_ADMINS,
               label: "BUCH_ADM",
               description: "Buchbereich Admin",
            },
            {
               bit: PermissionType.PERM_BUCH_OLA,
               label: "BUCH_OLA",
               description: "Buch OLA",
            },
            {
               bit: PermissionType.PERM_SUPERUSER,
               label: "SUPER",
               description: "Superuser / Admin",
            },
            {
               bit: PermissionType.PERM_THOMAS,
               label: "THOMAS",
               description: "Thomas-only Features",
            },
         ];
      },
   },

   watch: {
      "$store.state.auth.user": {
         // eslint-disable-next-line @typescript-eslint/no-explicit-any
         handler(newUser: any) {
            if (newUser && newUser.Permissions !== undefined) {
               // Only initialize originalPermissions on FIRST login
               if (!this.permissionsInitialized) {
                  this.originalPermissions = newUser.Permissions;
                  this.permissionsInitialized = true;
                  catVue.info(
                     `WATCH: First time - saved originalPermissions as 0x${newUser.Permissions.toString(
                        16,
                     ).toUpperCase()}`,
                  );
               }
               // Update current permissions and UI
               this.currentPermissions = newUser.Permissions;
               this.selectedPerms = this.permissionOptions
                  .filter((p) => (newUser.Permissions & p.bit) !== 0)
                  .map((p) => p.bit);
               catVue.info(
                  `Permission sync via watch: 0x${newUser.Permissions.toString(
                     16,
                  ).toUpperCase()}`,
               );
            }
         },
         deep: true,
      },
   },

   created(): void {
      catVue.info(`${this.$options.name}:: CREATED ... `);
      // Initialize UI from current store state
      const user = this.$store.state.auth.user;
      if (user) {
         this.currentPermissions = user.Permissions;
         this.selectedPerms = this.permissionOptions
            .filter((p) => (user.Permissions & p.bit) !== 0)
            .map((p) => p.bit);
         // Only save original if watch hasn't done it yet (shouldn't happen, but just in case)
         if (!this.permissionsInitialized) {
            this.originalPermissions = user.Permissions;
            this.permissionsInitialized = true;
            catVue.info(
               `CREATED: Initialized originalPermissions as 0x${user.Permissions.toString(
                  16,
               ).toUpperCase()}`,
            );
         }
      }
   },
});
